/* **************************************
*
* Redirection Script
* Crafted by PocketSquare
* https://pocketsquare.co.nz/
*
***************************************** */

/* methods */
let getCountry = function () {
	switch (window.top.location.hostname) {
		case `katesylvesterus.myshopify.com`:
		case `katesylvester.com`:
		case `katesylvesternz.myshopify.com`:
		case `katesylvester.co.nz`:
			return `NZ`
		case `katesylvesterau.myshopify.com`:
		case `katesylvester.com.au`:
			return `AU`
	}
}

let matchLocation = function (user, country) {
	if (country === user) {
		return true
	} else if (country === 'AU') {
		switch (user) {
			case `NZ`:
				return false
			case `AU`:
				return true
			default:
				return false
		}
	} else if (country === 'NZ') {
		switch (user) {
			case `NZ`:
				return true
			case `AU`:
				return false
			default:
				return false
		}
	} else {
		return false
	}
}

/* props */
let country = getCountry()
let redirect = {}
let token = window.PSRedirection.ipinfo_token

let $html = $('html')
let $body = $('body')
let $allPopups = $('.popup')
let $overlay = $('.overlay')
let $popupRedirection = $('.popup-redirection')

redirect = {
	urls: {
		au: `https://katesylvester.com.au${window.top.location.pathname}?geo_redirection_stay=1`,
		nz: `https://katesylvester.co.nz${window.top.location.pathname}?geo_redirection_stay=1`
	}
}

/* actions */
let locateUser = async () => {
	let response, data;
	data = localStorage.getItem('myIP');
	if (!data) {
		response = await fetch(`https://ipinfo.io/json?token=` + token);
		data = await response.json();
		localStorage.setItem('myIP', JSON.stringify(data));
	} else {
		data = JSON.parse(data)
	}
	return data
}

let setRedirection = (url, country) => {
	localStorage.setItem("preferredCountry", country);
	window.top.location.href = url;
}

$body.on('submit', '.popup-redirection form', function(e) {
	e.preventDefault()

	let $this = $(this)
	let redirectURL = $this.find('select').val()
	let redirectCountryCode = $this.find('select').find(':selected').data('code')

	if(redirectURL == '') {
		localStorage.setItem("closeRedirection", true)
		localStorage.setItem("preferredCountry", country)

		$html.removeClass('popup-shown')
		$allPopups.removeClass('shown')
		$overlay.removeClass('shown')
		slate.popUpShown = false
		slate.redirectPopupShown = false
	} else {
		setRedirection(redirectURL, redirectCountryCode)
	}
})

locateUser().then(c => {
	let showPopup = false
	let data = {}
	let option1 = ''
	let option1Value = ''
	let option1Code = ''
	let option2 = ''
	let option2Value = ''
	let option2Code = ''
	let optionAU = "Australia (AUD)"
	let optionNZ = "New Zealand (NZD)"

	switch(c.country) {
		case 'AU':
			option1 = optionAU
			if(country === 'AU') {
				option1Value = ''
			} else {
				option1Value = redirect.urls.au
			}
			option1Code = 'AU'

			option2 = optionNZ
			if(country === 'NZ') {
				option2Value = ''
			} else {
				option2Value = redirect.urls.nz
			}
			option2Code = 'NZ'
			break;

		case 'NZ':
		default:
			option1 = optionNZ
			if(country === 'NZ') {
				option1Value = ''
			} else {
				option1Value = redirect.urls.nz
			}
			option1Code = 'NZ'

			option2 = optionAU
			if(country === 'AU') {
				option2Value = ''
			} else {
				option2Value = redirect.urls.au
			}
			option2Code = 'AU'
	}

	if (redirect) {
		data = {
			title: "Are you in the right place?",
			description: "Please select your country and currency",
			option_1: option1,
			option_1_value: option1Value,
			option_1_code: option1Code,
			option_2: option2,
			option_2_value: option2Value,
			option_2_code: option2Code,
			buttonText: "Confirm"
		}

        showPopup = true
        
	}

	if (window.top.location.href.includes('geo_redirection_stay=1')) {
		localStorage.setItem("preferredCountry", country);
	}

	if (localStorage.preferredCountry && localStorage.preferredCountry !== country) {
		switch (localStorage.preferredCountry) {
			case 'AU':
				window.top.location.href = redirect.urls.au;
				break;
			case 'NZ':
			case 'US':
				window.top.location.href = redirect.urls.nz;
				break;
		}
	}

	if (matchLocation(c.country, country)) {
		return true
	} else {
		if (typeof localStorage.closeRedirection === 'undefined' && showPopup) {
			let source = $("#RedirectionPopupTemplate").html()
			let template = Handlebars.compile(source)

			$popupRedirection.append(template(data))

			$html.addClass('popup-shown')
			$allPopups.removeClass('shown')
			$popupRedirection.addClass('shown')
			$overlay.addClass('shown')

			setTimeout(function() {
				slate.popUpShown = true
				slate.redirectPopupShown = true
			}, 300)
		}
	}
})
.catch(err => console.error(err))
